module.exports = __webpack_public_path__ + "static/media/footer-copyright.f659e492.svg";